module.exports = __webpack_public_path__ + "img/SellAnywhere_Store1.e9f1b435.png";